import { useStyletron } from '@thanx/uikit/theme'

import palette from 'constants/palette'

import { ROW_GAP, SUB_ROW_PADDING_Y } from './uidRowStyles'

const GUIDE_WIDTH = '20px'
const LINE_WIDTH = '2px'
// Under the middle of the parent's checkbox
const LINE_LEFT = '7px'
// Level with the middle of the sub-row's checkbox
const BRANCH_TOP = `calc(${SUB_ROW_PADDING_Y} + 7px)`

/**
 * The indent of a store UID under its global, drawn as a tree: a line down
 * the whole row and a branch into the checkbox. Decorative only.
 */
const TreeGuide = () => {
  const [css] = useStyletron()
  const line = {
    position: 'absolute' as const,
    left: LINE_LEFT,
    backgroundColor: palette.grey40,
  }

  return (
    <span
      aria-hidden="true"
      className={css({
        position: 'relative',
        flex: `0 0 ${GUIDE_WIDTH}`,
        alignSelf: 'stretch',
        // Reaches the row's top and bottom edges through its padding
        margin: `-${SUB_ROW_PADDING_Y} 0`,
      })}
    >
      <span
        className={css({ ...line, top: 0, bottom: 0, width: LINE_WIDTH })}
      />
      <span
        className={css({
          ...line,
          top: BRANCH_TOP,
          height: LINE_WIDTH,
          width: `calc(${GUIDE_WIDTH} - ${LINE_LEFT} + ${ROW_GAP})`,
        })}
      />
    </span>
  )
}

export default TreeGuide
